import { useState } from "react";
import { MdVerified } from "react-icons/md";

type ThemeAvatarProps = {
  src?: string;
  alt?: string;
  name?: string; // 👈 add this
  size?: 'sm' | 'md' | 'lg' | 'xl';
  verified?: boolean;
  className?: string;
};

const sizeClasses = {
  sm: 'w-12 h-12 text-sm',
  md: 'w-20 h-20 text-lg',
  lg: 'w-28 h-28 text-2xl',
  xl: 'w-36 h-36 text-3xl'
};

const borderClasses = {
  sm: 'border-2',
  md: 'border-3',
  lg: 'border-4',
  xl: 'border-4'
};

export const ThemeAvatar: React.FC<ThemeAvatarProps> = ({ 
  src, 
  alt, 
  name,
  size = 'lg', 
  verified = false,
  className = ''
}) => {

  const [imgError, setImgError] = useState(false);

  const showFallback = !src || imgError;

  const initial = name?.charAt(0)?.toUpperCase() || "U";

  return (
    <div className="relative inline-block">
      
      {showFallback ? (
        // ✅ Fallback avatar
        <div
          className={`
            ${sizeClasses[size]} 
            ${borderClasses[size]} 
            rounded-full 
            flex items-center justify-center 
            bg-gradient-to-br from-purple-500 to-indigo-500 
            text-white font-bold
            border-gray-200 dark:border-gray-600
            ${className}
          `}
        >
          {initial}
        </div>
      ) : (
        // ✅ Image avatar
        <img
          src={src}
          alt={alt}
          onError={() => setImgError(true)} // 👈 handles broken image
          className={`
            ${sizeClasses[size]} 
            rounded-full 
            object-cover 
            ${borderClasses[size]} 
            border-gray-200 dark:border-gray-600 
            ${className}
          `}
        />
      )}

      {/* ✅ Verified badge */}
      {verified && (
        <div className="absolute -bottom-1 -right-1 bg-green-500 rounded-full p-1 border-2 border-white dark:border-gray-800">
          <MdVerified className="text-white text-xs" />
        </div>
      )}
    </div>
  );
};